import { useCallback, useState } from 'react';
import { IRankingCategories, ITeamWeekRank } from 'types';

const useGetRankings = () => {
  // #region DEFENSIVE STATS
  const [teamTotalYardsAllowed, setTeamTotalYardsAllowed] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassingYardsAllowed, setTeamTotalPassingYardsAllowed] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRushingYardsAllowed, setTeamTotalRushingYardsAllowed] = useState<ITeamWeekRank[]>([]);
  const [teamTotalSacks, setTeamTotalSacks] = useState<ITeamWeekRank[]>([]);
  const [teamTotalDefensiveInterceptions, setTeamTotalInterceptions] = useState<ITeamWeekRank[]>([]);
  const [teamTotalForcedFumbles, setTeamTotalForcedFumbles] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPointsAllowed, setTeamTotalPointsAllowed] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringPassingTDAgainst, setTeamTotalScoringPassingTDAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringRushingTDAgainst, setTeamTotalScoringRushingTDAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringFGAgainst, setTeamTotalScoringFGAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringEPAgainst, setTeamTotalScoringEPAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoring2PtAgainst, setTeamTotalScoring2PtAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringTotalTDAgainst, setTeamTotalScoringTotalTDAgainst] = useState<ITeamWeekRank[]>([]);
  // #endregion
  // #region OFFENSIVE STATS
  const [teamTotalYards, setTeamTotalYards] = useState<ITeamWeekRank[]>([]);
  const [teamTotalYardsPerPlay, setTeamTotalYardsPerPlay] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassingYards, setTeamTotalPassingYards] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassAttempts, setTeamTotalPassAttempts] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassCompletions, setTeamTotalPassCompletions] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassingPercentage, setTeamTotalPassPercentage] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassingYardsPerAttempt, setTeamTotalPassingYardsPerAttempt] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRushingYards, setTeamTotalRushingYards] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRushingAttempts, setTeamTotalRushingAttempts] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRushingYardsPerAttempt, setTeamTotalRushingYardsPerAttempt] = useState<ITeamWeekRank[]>([]);
  const [teamTotalInterceptionsThrown, setTeamTotalInterceptionsThrown] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPenalties, setTeamTotalPenalties] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPenaltyYards, setTeamTotalPenaltyYards] = useState<ITeamWeekRank[]>([]);
  const [teamTotalTimeOfPossession, setTeamTotalTimeOfPossession] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPointsScored, setTeamTotalPointsScored] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPlays, setTeamTotalPlays] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFumblesLost, setTeamTotalFumblesLost] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringPassingTDFor, setTeamTotalScoringPassingTDFor] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringRushingTDFor, setTeamTotalScoringRushingTDFor] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringFGFor, setTeamTotalScoringFGFor] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringEPFor, setTeamTotalScoringEPFor] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoring2PtFor, setTeamTotalScoring2PtFor] = useState<ITeamWeekRank[]>([]);
  const [teamTotalScoringTotalTDFor, setTeamTotalScoringTotalTDFor] = useState<ITeamWeekRank[]>([]);
  const [teamTotalSafeties, setTeamTotalSafeties] = useState<ITeamWeekRank[]>([]);
  const [teamTotalDefensiveOrSpecialTeamsTds, setTeamTotalDefensiveOrSpecialTeamsTds] = useState<ITeamWeekRank[]>([]);

  const [teamTotalSackedTimes, setTeamTotalSackedTimes] = useState<ITeamWeekRank[]>([]);
  const [teamTotalSackedYardsLost, setTeamTotalSackedYardsLost] = useState<ITeamWeekRank[]>([]);
  const [teamTotalDrives, setTeamTotalDrives] = useState<ITeamWeekRank[]>([]);
  const [teamTotalThirdDownAttempts, setTeamTotalThirdDownAttempts] = useState<ITeamWeekRank[]>([]);
  const [teamTotalThirdDownConverted, setTeamTotalThirdDownConverted] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRedZoneScored, setTeamTotalRedZoneScored] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRedZoneAttempts, setTeamTotalRedZoneAttempts] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFirstDowns, setTeamTotalFirstDowns] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFirstDownsFromPenalties, setTeamTotalFirstDownsFromPenalties] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFirstDownsFromRushing, setTeamTotalFirstDownsFromRushing] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFirstDownsFromPassing, setTeamTotalFirstDownsFromPassing] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFourthDownAttempts, setTeamTotalFourthDownAttempts] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFourthDownScored, setTeamTotalFourthDownScored] = useState<ITeamWeekRank[]>([]);

  const [teamTotalThirdDownEfficiency, setTeamTotalThirdDownEfficiency] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFourthDownEfficiency, setTeamTotalFourthDownEfficiency] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRedZoneEfficiency, setTeamTotalRedZoneEfficiency] = useState<ITeamWeekRank[]>([]);

  const [teamTotalPassIncompletions, setTeamTotalPassIncompletions] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassAttemptsAgainst, setTeamTotalPassAttemptsAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalPassIncompletePercentage, setTeamTotalPassIncompletePercentage] = useState<ITeamWeekRank[]>([]);
  const [teamTotalThirdDownAttemptsAgainst, setTeamTotalThirdDownAttemptsAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalThirdDownStops, setTeamTotalThirdDownStops] = useState<ITeamWeekRank[]>([]);
  const [teamTotalThirdDownStopEfficiency, setTeamTotalThirdDownStopEfficiency] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFourthDownStops, setTeamTotalFourthDownStops] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFourthDownAttemptsAgainst, setTeamTotalFourthDownAttemptsAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalFourthDownStopEfficiency, setTeamTotalFourthDownStopEfficiency] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRedZoneStops, setTeamTotalRedZoneStops] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRedZoneAttemptsAgainst, setTeamTotalRedZoneAttemptsAgainst] = useState<ITeamWeekRank[]>([]);
  const [teamTotalRedZoneStopEfficiency, setTeamTotalRedZoneStopEfficiency] = useState<ITeamWeekRank[]>([]);

  // #endregion

  const initRankings = useCallback((rankCats: IRankingCategories) => {
    if (rankCats) {
      setTeamTotalYards(rankCats.totalYards?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPlays(rankCats.totalPlays?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalYardsPerPlay(rankCats.totalYardsPerPlay?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassingYards(rankCats.totalPassingYards?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassAttempts(rankCats.totalPassAttempts?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassCompletions(rankCats.totalPassCompletions?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassPercentage(rankCats.totalPassingPercentage?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassingYardsPerAttempt(rankCats.totalPassingYardsPerAttempt?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRushingYards(rankCats.totalRushingYards?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRushingAttempts(rankCats.totalRushingAttempts?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRushingYardsPerAttempt(rankCats.totalRushingYardsPerAttempt?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPointsScored(rankCats.totalPointsScored?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalInterceptionsThrown(rankCats.totalInterceptionsThrown?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFumblesLost(rankCats.totalFumblesLost?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalTimeOfPossession(rankCats.totalTimeOfPossession?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPenalties(rankCats.totalPenalties?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPenaltyYards(rankCats.totalPenaltyYards?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalYardsAllowed(rankCats.totalYardsAllowed?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassingYardsAllowed(rankCats.totalPassingYardsAllowed?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRushingYardsAllowed(rankCats.totalRushingYardsAllowed?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPointsAllowed(rankCats.totalPointsAllowed?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalSacks(rankCats.totalSacks?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalInterceptions(rankCats.totalDefensiveInterceptions?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalForcedFumbles(rankCats.totalForcedFumbles?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalSafeties(rankCats.totalSafeties?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalDefensiveOrSpecialTeamsTds(
        rankCats.totalDefensiveOrSpecialTeamsTds?.adjustedRanking as ITeamWeekRank[]
      );
      setTeamTotalScoringTotalTDFor(rankCats.totalScoringTotalTDFor?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringTotalTDAgainst(rankCats.totalScoringTotalTDAgainst?.adjustedRanking as ITeamWeekRank[]);

      setTeamTotalScoringPassingTDAgainst(rankCats.totalScoringPassingTDAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringRushingTDAgainst(rankCats.totalScoringRushingTDAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringFGAgainst(rankCats.totalScoringFGAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringEPAgainst(rankCats.totalScoringEPAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoring2PtAgainst(rankCats.totalScoring2PtAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringPassingTDFor(rankCats.totalScoringPassingTDFor?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringRushingTDFor(rankCats.totalScoringRushingTDFor?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringFGFor(rankCats.totalScoringFGFor?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoringEPFor(rankCats.totalScoringEPFor?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalScoring2PtFor(rankCats.totalScoring2PtFor?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalSackedTimes(rankCats.totalSackedTimes?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalSackedYardsLost(rankCats.totalSackedYardsLost?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalDrives(rankCats.totalDrives?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalThirdDownAttempts(rankCats.totalThirdDownAttempts?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalThirdDownConverted(rankCats.totalThirdDownConverted?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRedZoneScored(rankCats.totalRedZoneScored?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRedZoneAttempts(rankCats.totalRedZoneAttempts?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFirstDowns(rankCats.totalFirstDowns?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFirstDownsFromPenalties(rankCats.totalFirstDownsFromPenalties?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFirstDownsFromRushing(rankCats.totalFirstDownsFromRushing?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFirstDownsFromPassing(rankCats.totalFirstDownsFromPassing?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFourthDownAttempts(rankCats.totalFourthDownAttempts?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFourthDownScored(rankCats.totalFourthDownScored?.adjustedRanking as ITeamWeekRank[]);

      setTeamTotalThirdDownEfficiency(rankCats.totalThirdDownEfficiency?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFourthDownEfficiency(rankCats.totalFourthDownEfficiency?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRedZoneEfficiency(rankCats.totalRedZoneEfficiency?.adjustedRanking as ITeamWeekRank[]);

      setTeamTotalPassIncompletions(rankCats.totalPassIncompletions?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassAttemptsAgainst(rankCats.totalPassAttemptsAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalPassIncompletePercentage(rankCats.totalPassIncompletePercentage?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalThirdDownAttemptsAgainst(rankCats.totalThirdDownAttemptsAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalThirdDownStops(rankCats.totalThirdDownStops?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalThirdDownStopEfficiency(rankCats.totalThirdDownStopEfficiency?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFourthDownStops(rankCats.totalFourthDownStops?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalFourthDownAttemptsAgainst(
        rankCats.totalFourthDownAttemptsAgainst?.adjustedRanking as ITeamWeekRank[]
      );
      setTeamTotalFourthDownStopEfficiency(rankCats.totalFourthDownStopEfficiency?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRedZoneStops(rankCats.totalRedZoneStops?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRedZoneAttemptsAgainst(rankCats.totalRedZoneAttemptsAgainst?.adjustedRanking as ITeamWeekRank[]);
      setTeamTotalRedZoneStopEfficiency(rankCats.totalRedZoneStopEfficiency?.adjustedRanking as ITeamWeekRank[]);
    }
  }, []);

  return {
    initRankings,

    teamTotalYards, // 1
    teamTotalYardsPerPlay, // 2
    teamTotalPassingYards, // 3
    teamTotalRushingYards, // 4
    teamTotalPassAttempts, // 5
    teamTotalPassCompletions, // 6
    teamTotalPassingPercentage, // 7
    teamTotalPassingYardsPerAttempt, // 8
    teamTotalRushingAttempts, // 9
    teamTotalRushingYardsPerAttempt, // 10
    teamTotalPointsScored, // 11
    teamTotalInterceptionsThrown, // 12
    teamTotalPlays, // 13
    teamTotalFumblesLost, // 14

    teamTotalTimeOfPossession, // 15
    teamTotalPenalties, // 16
    teamTotalPenaltyYards, // 17

    teamTotalYardsAllowed, // 18
    teamTotalPassingYardsAllowed, // 19
    teamTotalRushingYardsAllowed, // 20
    teamTotalPointsAllowed, // 21
    teamTotalSacks, // 22
    teamTotalDefensiveInterceptions, // 23
    teamTotalForcedFumbles, // 24
    teamTotalSafeties, // 25
    teamTotalDefensiveOrSpecialTeamsTds, // 26

    teamTotalScoringPassingTDAgainst, // 27
    teamTotalScoringRushingTDAgainst, // 28
    teamTotalScoringFGAgainst, // 29
    teamTotalScoringEPAgainst, // 30
    teamTotalScoring2PtAgainst, // 31
    teamTotalScoringPassingTDFor, // 32
    teamTotalScoringRushingTDFor, // 33
    teamTotalScoringFGFor, // 34
    teamTotalScoringEPFor, // 35
    teamTotalScoring2PtFor, // 36
    teamTotalScoringTotalTDFor, // 37
    teamTotalScoringTotalTDAgainst, // 38

    teamTotalSackedTimes, // 39
    teamTotalSackedYardsLost, // 40
    teamTotalDrives, // 41
    teamTotalThirdDownAttempts, // 42
    teamTotalThirdDownConverted, // 43
    teamTotalRedZoneScored, // 44
    teamTotalRedZoneAttempts, // 45
    teamTotalFirstDowns, // 46
    teamTotalFirstDownsFromPenalties, // 47
    teamTotalFirstDownsFromRushing, // 48
    teamTotalFirstDownsFromPassing, // 49
    teamTotalFourthDownAttempts, // 50
    teamTotalFourthDownScored, // 51

    teamTotalThirdDownEfficiency, // 52
    teamTotalFourthDownEfficiency, // 53
    teamTotalRedZoneEfficiency, // 54

    teamTotalPassIncompletions, // 55
    teamTotalPassAttemptsAgainst, // 56
    teamTotalPassIncompletePercentage, // 57
    teamTotalThirdDownAttemptsAgainst, // 58
    teamTotalThirdDownStops, // 59
    teamTotalThirdDownStopEfficiency, // 60
    teamTotalFourthDownStops, // 61
    teamTotalFourthDownAttemptsAgainst, // 62
    teamTotalFourthDownStopEfficiency, // 63
    teamTotalRedZoneStops, // 64
    teamTotalRedZoneAttemptsAgainst, // 65
    teamTotalRedZoneStopEfficiency, // 66
  };
};

export default useGetRankings;
